import { render, staticRenderFns } from "./ImpactCard.vue?vue&type=template&id=1111ba28"
import script from "./ImpactCard.vue?vue&type=script&lang=js"
export * from "./ImpactCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports